import React from 'react';
import {MasterLayout} from 'components/layouts';
import {NewsCategory} from 'components/news';
import title from 'constants/TitlePages.js';

class NewsCategoryPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  componentDidMount() {
    document.title = title.NewsCategoryPage;
  }

  render() {
    return (
      <MasterLayout pageClass='news-category-page'>
        <NewsCategory params={this.props.match.params}/>
      </MasterLayout>
    );
  }
}

export default NewsCategoryPage;



// WEBPACK FOOTER //
// ./pages/news/NewsCategoryPage.jsx